import React from 'react';
import { Flex, css } from 'theme-ui';
import styles from './styles';

const KnowledgeBaseArticleAside = ({ content: { buttons } }) => (
  <Flex sx={styles.container}>
    <Flex as='aside' sx={styles.aside}>
      <p css={css(styles.navTitle)}>ON THIS PAGE</p>
      {buttons.map((button, index) => (
        <a
          key={`aside-link-${index}`}
          css={css(styles.navLink)}
          href={button.link}
        >
          {button.text}
        </a>
      ))}
    </Flex>
  </Flex>
);

export default KnowledgeBaseArticleAside;
